export default [
  {
    path: '',
    name: 'home',
    component: () => import('@/views/MinistryHome.vue'),
    meta: {
      pageTitle: 'Statistics',
      breadcrumb: [
        {
          text: 'Statistics',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
